// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1N2fm","col":"CardReaderDesc_col__2X47z","label":"CardReaderDesc_label__3M03-"};